import { Chip } from "@mui/material";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";

const StatusOrderChip = ({ status }: { status: string }) => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const statuses = [
    {
      label: t("status.planning"),
      name: "Planning",
      backgroundColor: "#e0f7fa",
      color: "#00796b",
    },
    {
      label: t("status.opened"),
      name: "Opened",
      backgroundColor: "#e3f2fd",
      color: "#3f77a4",
    },
    {
      label: t("status.closed"),
      name: "Closed",
      backgroundColor: "#e0e0e0",
      color: "#616161",
    },
    {
      label: t("status.accepted"),
      name: "Accepted",
      backgroundColor: "#cdeeeb",
      color: "#00a046",
    },
    {
      label: t("status.payment"),
      name: "Payment",
      backgroundColor: "#ffecb3",
      color: "#ff6f00",
    },
    {
      label: t("status.paymentConfirmation"),
      name: "PaymentConfirmation",
      backgroundColor: "#ffe0b2",
      color: "#bf360c",
    },
    {
      label: t("status.sendingLabel"),
      name: "Sending",
      backgroundColor: "#d1c4e9",
      color: "#512da8",
    },
    {
      label: t("status.receiving"),
      name: "Receiving",
      backgroundColor: "#dcedc8",
      color: "#33691e",
    },
    {
      label: t("status.finished"),
      name: "Finished",
      backgroundColor: "#ffccbc",
      color: "#bf360c",
    },
    {
      label: t("status.canceled"),
      name: "Canceled",
      backgroundColor: "#ffcdd2",
      color: "#c62828",
    },
  ];

  // Find the status object from the statuses array
  const statusProps = statuses.find((s) => s.name === status) || statuses[0]; // Default to the first status
  return (
    <Chip
      label={statusProps.label}
      sx={{
        backgroundColor: statusProps.backgroundColor,
        color: statusProps.color,
        fontWeight: 600,
        fontSize: "13px",
        borderRadius: "30px",
        height: "25px",
        margin: "auto",
        textAlign: "center",
      }}
    />
  );
};

export default StatusOrderChip;
